import { CloseSquare } from 'iconsax-react';
import CustomModal from './CustomModal';
import { useTranslation } from 'react-i18next';
import Button from './Button';

export default function DeleteModal({
  title,
  isOpen,
  onClose,
  onDelete,
  isLoading,
  description,
  actionText,
}: {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading?: boolean;
  description?: string;
  actionText?: string;
}) {
  const { t } = useTranslation();

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      centered
      closable={false}
      width={715}
      bodyStyle={{ padding: 0 }}
    >
      <div className="rounded-[12px] bg-white p-[20px] text-center shadow-[0_10px_20px_rgba(92,115,160,0.07)] dark:bg-dark-surface-secondary" data-testid="delete-modal-container">
        <div className="mx-auto mb-[30px] flex h-[44px] w-[44px] items-center justify-center rounded-xl border border-[#CC2936] bg-[#FAF2F3]" data-testid="delete-modal-icon-wrapper">
          <CloseSquare size={16} variant="Linear" color="#CC2936" />
        </div>

        <div className="space-y-[10px] max-w-[655px] mx-auto" data-testid="delete-modal-text-content">
          <h3 className="text-[24px] font-semibold leading-[32px] text-light-text-primary dark:text-dark-text-primary" data-testid="delete-modal-title">
            {title || t('deleteModal.title')}
          </h3>
          <p className="text-[14px] leading-[22px] text-[#777777] dark:text-dark-text-secondary" data-testid="delete-modal-description">
            {description || t('deleteModal.description')}
          </p>
        </div>

        <div className="mt-[30px] flex items-center justify-end gap-[8px]" data-testid="delete-modal-actions">
          <Button
            variant="outline"
            disabled={isLoading}
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="w-[113px] h-[46px] rounded-[12px] border-[#090909] text-[#090909] bg-white text-[16px] font-semibold"
            data-testid="delete-modal-cancel-btn"
          >
            {t('cancel')}
          </Button>

          <Button
            variant="danger"
            className="w-[181px] h-[46px] rounded-[12px] bg-[#CC2936] border-[#CC2936] text-white hover:opacity-90 text-[16px] font-semibold"
            onClick={(e) => {
              e.stopPropagation();
              onDelete?.();
            }}
            disabled={isLoading}
            loading={isLoading}
            data-testid="delete-modal-confirm-btn"
          >
            {actionText || t('deleteModal.confirm')}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
